import Grid from "@material-ui/core/Grid";
import { useFormState } from "react-final-form";

const VideoPreview = () => {
  const { values } = useFormState();
  const videoUrl = values.video_url;

  if (!videoUrl) return null;

  return (
      <Grid item xs={6}>
          <div style={{ margin: "0 0 10px 0", color: "rgba(0, 0, 0, 0.54)", fontSize: "14px" }}>Video Preview</div>
          <video
              src={videoUrl ? `https://lashbrook-customizer-prod.s3.us-west-2.amazonaws.com/bestsellers/${videoUrl}` : null}
              controls
              style={{
                  width: "100%",
                  height: "400px",
              }}
              autoPlay
              muted
              loop
              playsInline
          />
      </Grid>
  );
};

export default VideoPreview;